import { useMutation, MutationFunction, MutationOptions } from 'react-query';
import { deleteDailyMachine, DeleteDailyMachineResponse, createDailyMachine } from '../../services/apiSLTP/planning';
import { DailyMachineResponse, updateDailyMachine, UpdateDailyMachineBody, UpdateDailyMachineQueries } from '../../services/apiSLTP/activities';

type UseDeleteDailyMachineMutationOptions = MutationOptions<DeleteDailyMachineResponse, Error, { id: string }>;

export const useDeleteDailyMachineMutation = (options?: UseDeleteDailyMachineMutationOptions) => {
    const deleteDailyMachineMutation: MutationFunction<DeleteDailyMachineResponse, { id: string }> = async ({ id }) => {
        try {
            const response: DeleteDailyMachineResponse = await deleteDailyMachine(id);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during delete daily machine');
        }
    };

    return useMutation(deleteDailyMachineMutation, options);
};

type UseCreateDailyMachineMutationOptions = MutationOptions<
    DailyMachineResponse,
    Error,
    { activityId: string; machineId: string; state: number; isUsed: boolean; createTransfer?: boolean; quantity: number }
>;

export const UseCreateDailyMachineMutation = (options?: UseCreateDailyMachineMutationOptions) => {
    const createDailyMachineMutation: MutationFunction<
        DailyMachineResponse,
        { activityId: string; machineId: string; state: number; isUsed: boolean; createTransfer?: boolean; quantity?: number }
    > = async ({ activityId, machineId, state, isUsed, createTransfer, quantity }) => {
        try {
            const response: DailyMachineResponse = await createDailyMachine(activityId, machineId, state, createTransfer, undefined, undefined, quantity);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during create daily machine');
        }
    };

    return useMutation(createDailyMachineMutation, options);
};

type UseDailyMachineMutationOptions = MutationOptions<DailyMachineResponse, Error, { id: string; body: UpdateDailyMachineBody, queries?: UpdateDailyMachineQueries }>;

export const UseDailyMachineMutation = (options?: UseDailyMachineMutationOptions) => {
    const updateDailyMachineMutation: MutationFunction<DailyMachineResponse, { id: string; body: UpdateDailyMachineBody, queries?: UpdateDailyMachineQueries }> = async ({ id, body, queries }) => {
        try {
            const response: DailyMachineResponse = await updateDailyMachine(id, body, queries);
            return response;
        } catch (error) {
            throw new Error('An unexpected error occurred during update daily machine');
        }
    };

    return useMutation(updateDailyMachineMutation, options);
};
